export const alphabeticalSorting = (x, y, locale) => {
    if (!x.name) {
        return 1;
    }
    if (!y.name) {
        return -1;
    }
    return x.name.toLocaleLowerCase().localeCompare(y.name.toLocaleLowerCase(), locale, { numeric: true });
};
//# sourceMappingURL=alphabeticalSorting.js.map